import React, { useRef, useState, useEffect, useCallback } from "react";
import { BASE_HEIGHT, BASE_WIDTH } from "../games/cardComponent";

interface ExpandToFitContainerProps {
  children: React.ReactNode;
  maxScale?: number;
  minScale?: number;
}

export const ExpandToFitContainer: React.FC<ExpandToFitContainerProps> = ({
  children,
  maxScale = Infinity,
  minScale = 0.1,
}) => {
  const containerRef = useRef<HTMLDivElement>(null);
  const [scale, setScale] = useState(1);

  const updateScale = useCallback(() => {
    if (!containerRef.current) return;

    const containerWidth = containerRef.current.clientWidth;
    const newScale = Math.max(
      minScale,
      Math.min(maxScale, containerWidth / BASE_WIDTH)
    );
    setScale(newScale);
  }, [maxScale, minScale]);

  useEffect(() => {
    updateScale();

    const resizeObserver = new ResizeObserver(updateScale);
    if (containerRef.current) {
      resizeObserver.observe(containerRef.current);
    }

    return () => resizeObserver.disconnect();
  }, [updateScale]);

  return (
    <div
      ref={containerRef}
      style={{
        width: "100%",
        display: "flex",
        justifyContent: "center",
        alignItems: "flex-start",
      }}
    >
      <div
        style={{
          width: `${BASE_WIDTH * scale}px`,
          height: `${BASE_HEIGHT * scale}px`,
          position: "relative",
          overflow: "hidden",
        }}
      >
        <div
          style={{
            transformOrigin: "top left",
            transform: `scale(${scale})`,
            width: `${BASE_WIDTH}px`,
            height: `${BASE_HEIGHT}px`,
            position: "absolute",
            top: 0,
            left: 0,
          }}
        >
          {children}
        </div>
      </div>
    </div>
  );
};